
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { PhotoUploadFormValues } from "../../hooks/usePhotoUploadForm";
import { PhotoFormFields } from "../photo-shared/PhotoFormFields";

interface PhotoUploadFormProps {
  form: UseFormReturn<PhotoUploadFormValues>;
  isAdmin?: boolean;
  onCopyFromCaption: () => void;
  disabled?: boolean;
  onYOffsetChange?: (value: number) => void;
  previewImageSrc?: string | null;
}

export const PhotoUploadForm: React.FC<PhotoUploadFormProps> = (props) => {
  return <PhotoFormFields {...props} />;
};
